<template>
  <div :class="container">
    <p>
      江苏和悦医疗科技有限公司（以下简称“公司”）成立于2021
      年。母公司连云港泽高企业管理咨询公司坐落在中国水晶之都连云港市东海县高新技术开发区。
    </p>
    <p>
      2021年，总公司作为重点企业，由响水县响水镇人民政府招商引入。在响水镇人民政府成立全资子公司江苏和悦医疗科技有限公司。主要从事医疗一、二、三类器械销售推广、技术服务、物流配送、技术进出口、进出口代理、医院管理、SPD
      服务等。产品线包括骨科、普外、介入、护理、医疗设备、试剂、慢病、运动医学、营养科共建、特医食品、电子商务等。总公司旗下现有一般纳税人经营企业江苏和悦医疗科技有限公司，小规模经营企业三个；拥有多项国家专利的特医食品生产企业江苏生息元健康食品有限公司。公司拥有减肥代餐、糖尿病代餐、手术重症病人营养支持产品等八大类十六个品规的全国范围内的线上线下总经销权；自主研发生产的二类器械品种一个，目前业务覆盖16
      个省。公司现与省内五家二三级医院营养科共建。公司前身江苏东泰医药有限公司2011年与南京中医药大学达成校企联盟，依托南京中医科大学的强大的研发能力，凭借人工合成阿克曼菌前体蛋白技术在国际权威杂志上获得了银奖。在生息元全营养浓浆加入阿克曼菌前体蛋白，达到减肥和降糖的作用。在国内医学界首次提出医院营养科应大力开展减肥，降糖的理论，为营养科发展注入了全新的动力并得到了包括扬州市江都人民医院等五家共建医院的全力认可。
    </p>
    <p>
      择高处立，就平处坐，向宽处行，公司自成立以来，积极践行民企职责及强烈的社会责任感，在国家大疫来临的时候，公司领导大爱无言，先后给武汉疫区、响水县发改委、卫健委、县医院、中医院等捐赠了价值
      220
      多万的防疫物资，在一定程度上缓解了武汉及响水县防疫物资短缺的情况。在知悉兄弟县滨海县院防疫物资有需求的情况下，秉承公司“科技创新，和天下，悦四方”的企业理念，当即决定捐赠上万套高级医疗防护衣物等给滨海县人民医院。公司遵循“
      良知 良能诚意
      正心”的企业价值观；立足“线下服务专注，线上服务精准”的战略定位，牢记“服务至上、客户至上
      ”的服务宗旨，线下专注于医疗供应链管理与服务，线上精准服务肥胖、糖尿病、手术重症病人等特殊人群；致力打造区域内最优质的医疗科技服务良心运营商，和悦人一直在努力。
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      container: "container",
    };
  },
};
</script>

<style type="css">
.container {
  max-width: 1200px;
  text-align: left;
  margin:0 auto;
  line-height: 200%;
  text-indent: 2em;
  font-size: 19px;;
}
</style>